import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import CoachEditor from "../../editors/resources/coach";

const Coaches: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.CoachesList}
			endpoint={Endpoint.Coaches}
			addScreen={{ screen: CoachEditor, isAllowed: hasPermission(Permission.CoachesAdd) }}
			editScreen={{ screen: CoachEditor, isAllowed: hasPermission(Permission.CoachesUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.CoachesDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="company.name" title={t("company")} />
			<GridColumn field="jobFunction.name" title={t("jobFunction")} />
			<GridColumn field="internal" title={t("internal")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Coaches;
